(function ($) {

  const initializeBlock = function ($block) {
    const $slider = $block.find('.imageSlider')
    if($slider.hasClass('slick-initialized')) {
      $slider.slick('unslick');
    }

    if ($slider.hasClass('arrows')) {
      var arrowsBool = true;
      var autoPlaySpeedValue = 7000
    } else {
      var arrowsBool = false;
      var autoPlaySpeedValue = 5000
    }
    $slider.slick({
      dots: false,
      arrows: arrowsBool,
      infinite: true,
      autoplay: true,
      autoplaySpeed: autoPlaySpeedValue,
      fade: true,
      cssEase: 'linear',
      slidesToShow: 1,
      slidesToScroll: 1,
      pauseOnHover: false,
      asNavFor: '.imageSliderNav',
    })

    const $slider_nav = $block.find('.imageSliderNav')
    if($slider_nav.hasClass('slick-initialized')) {
      $slider_nav.slick('unslick');
    }
    $slider_nav.slick({
      dots: false,
      arrows: false,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 5000,
      slidesToShow: 4,
      slidesToScroll: 1,
      pauseOnHover: false,
      asNavFor: '.imageSlider',
      responsive: [
        {
          breakpoint: 1280,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
            centerPadding: '0px',
          },
        },
        {
          breakpoint: 769,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            centerPadding: '0px',
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            centerPadding: '0px',
          },
        },
      ],
    })

    // Click to go to slide
    $('.imageSliderNav-item').click(function(event) {
      var slideTarget = $(this).attr('data-slick-index')
      $block.find('.imageSliderNav').slick('slickGoTo', slideTarget)
    });
  }

  $(document).ready(function () {
    $('.block--image-slider').each(function () {
      initializeBlock($(this));
    })
  })

  if (window.acf) {
    window.acf.addAction('render_block_preview/type=image-slider', initializeBlock);
  }

})(jQuery);
